import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi"; // Eye icon for password toggle
import HdfcLogo from "../assets/hdfc-life.png";

import DocumentIllustration from "./../assets/images/TransferSuccessBW.svg";
import axios from "axios";

const WelcomeScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 95vh;
  background-color: #ffffff;
  padding: 20px;
  position: relative;
`;

const BottomContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 90%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 20px;
`;

const Logo = styled.img`
  width: 150px;
  position: absolute;
  top: 20px;
  left: 20px;
`;

const ContentWrapper = styled.div`
  flex: 1; /* Takes up remaining space */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  padding: 0 20px;
`;


const Illustration = styled.img`

  margin: 20px auto 20px; /* Center the image */
  object-fit: contain;


 
`;

const InputWrapper = styled.div`
  position: relative;
  width: 90%;
`;

const CustomInput = styled.input`
  font-size: 16px;
  padding: 10px 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const EyeIcon = styled.div`
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #777;
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 10px;
`;

const ProceedButton = styled.button`
  margin-top: 10px;
  padding: 12px 20px;
  font-size: 16px;
  background-color: #000000;
  color: white;
  border: none;
  border-radius: 5px;
  width: 99%;
  max-width: 400px;
  cursor: pointer;

  &:hover {
    background-color: #333333;
  }
`;
const WelcomeScreen = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/terms");
  }

 const handleProceed = async () => {
   try {
     const response = await axios.post(
       "https://pivv-be.yhealth.me/api/validate-code",
       { code: password },
       {
         headers: {
           "x-api-key":
             "zrEjEPASSLwXksLSBrPtIHTBowGWhttrLvH00sZ96VRNPruYlePN8ZlujLCuyCoqQBbf52TLdCxHZCDAs05NbNZ4zGUDBNuOa7G88CYMvz21lHzy6FI7AXabiOPrtQOE",
           "Content-Type": "application/json",
         },
       }
     );

     if (response.data.success) {
       localStorage.setItem("userPassword", password);
      handleNavigation();
     } else {
       console.log("Invalid code. Showing error message.");
       setError(response.data.message || "Invalid code. Please try again.");
     }
   } catch (error) {
     console.error("API Call Error:", error);
     setError(
       error.response?.data?.message ||
         "Something went wrong. Please try again later."
     );
   }
 };

  // const handleProceed = () => {
  //   if (password !== "y2024") {
  //     setError("Incorrect password. Please try again.");
  //     return;
  //   }
  //   localStorage.setItem("userPassword", password);
  //   navigate("/terms");
  // };

  return (
   <WelcomeScreenContainer>
      <Logo src={HdfcLogo} alt="HDFC Life Logo" />
      <ContentWrapper>
        <Illustration src={DocumentIllustration} alt="Document Illustration" />
      </ContentWrapper>

      {/* Bottom section containing input and button */}
      <BottomContainer>
        <p
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: "18px",
            lineHeight: "1.5",
            marginBottom: "16px",
            marginTop: "20px",
          }}
        >
          Welcome to our PIVC! Please enter the password to get started
        </p>
        <InputWrapper>
          <CustomInput
            type={showPassword ? "text" : "password"}
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <EyeIcon onClick={() => setShowPassword(!showPassword)}>
            {showPassword
              ? React.createElement(FiEyeOff as any)
              : React.createElement(FiEye as any)}
          </EyeIcon>
        </InputWrapper>

        {error && (
          <ErrorMessage
            style={{
              textAlign: "left",
              maxWidth: "300px",
              marginBottom: "10px",
            }}
          >
            {error}
          </ErrorMessage>
        )}

        <ProceedButton onClick={handleProceed}>Proceed</ProceedButton>
      </BottomContainer>
    </WelcomeScreenContainer>
  );
};

export default WelcomeScreen;
